import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { BuildingOrg } from 'shared/models';
import { CheckField } from 'ui/shared/controls';
import { propertyNameLabelKeys } from '../../orgRoles';

require('./OrgRoleOption.css');

export type OrgRoleOptionData = {
    labelKey: string;
    propertyName: keyof BuildingOrg['properties'];
    visible: boolean;
    replaceFirst: boolean;
    disabled?: boolean;
    replaceNames?: string[];
};

export type Props = OrgRoleOptionData & {
    data: {
        properties: BuildingOrg['properties'];
        replace: BuildingOrg['properties'];
    };
    onChange(e: ChangeEvent<HTMLInputElement>): void;
};

export const OrgRoleOption = ({ labelKey, propertyName, data, replaceFirst, disabled = false, replaceNames = [], onChange }: Props) => {
    const { t } = useTranslation();
    const roleName = t(propertyNameLabelKeys[propertyName]).toLocaleLowerCase();
    return (
        <li className="org-role-option">
            <CheckField
                id={ `org-role-option-${propertyName}` }
                labelKey={ labelKey }
                disabled={ disabled }
                input={ {
                    name: `properties.${propertyName}`,
                    checked: !!data.properties[propertyName],
                    onChange,
                } }
            />
            { replaceFirst &&
                <i
                    className="ui small grey open question circle outline icon"
                    title={ t('BUILDING.ORGS.LABEL.REPLACE_FIRST') }
                />
            }
            { replaceNames.length > 0 && !!data.properties[propertyName] &&
                <div className="_replace">
                    <CheckField
                        id={ `org-role-option-replace-${propertyName}` }
                        label={ t('BUILDING.ORGS.LABEL.ROLE_REPLACE', [ replaceNames.join(', '), roleName ]) }
                        input={ {
                            name: `replace.${propertyName}`,
                            checked: !!data.replace[propertyName],
                            onChange,
                        } }
                    />
                </div>
            }
        </li>
    );
};
